import React from 'react';
import { Route } from 'react-router-dom';
import Airports from '../pages/airports/Airports';
import CreateAirport from '../pages/airports/CreateAirport';
import EditAirport from '../pages/airports/EditAirport';
import AirportDetails from '../pages/airports/AirportDetails';
import ProtectedRoute from '../components/global/ProtectedRoute';

const airportsRoutes = (
    <>
        {/* Airports List */}
        <Route
            path="/airports"
            element={
                <ProtectedRoute requiredPermission="airports_list">
                    <Airports />
                </ProtectedRoute>
            }
        />

        {/* Airports Archive */}
        <Route
            path="/airports/archive"
            element={
                <ProtectedRoute requiredPermission="airports_archive_list">
                    <Airports />
                </ProtectedRoute>
            }
        />

        {/* Create Airport */}
        <Route
            path="/airports/create"
            element={
                <ProtectedRoute requiredPermission="airports_create">
                    <CreateAirport />
                </ProtectedRoute>
            }
        />

        {/* Edit Airport */}
        <Route
            path="/airports/:id/edit"
            element={
                <ProtectedRoute requiredPermission="airports_edit">
                    <EditAirport />
                </ProtectedRoute>
            }
        />

        {/* Show Airport */}
        <Route
            path="/airports/:id"
            element={
                <ProtectedRoute requiredPermission="airports_show">
                    <AirportDetails />
                </ProtectedRoute>
            }
        />
    </>
);

export default airportsRoutes;
